 <div class="custom-snackbar-container">
  <div>
    <div [innerHTML]="data.html"></div>
  </div>
   <div  class="actions-buttons-wrapper">
     <button mat-button  color="primary" (click)="closeSnackBar()">Ok</button>
   </div>
 </div>
